'use client';

import { GaLog } from '@components/common/PageView';
import { getSpcItemListParam } from '@components/pages/spc/SpcProductList/ga4';
import useGlobalState from '@hooks/useGlobalState';
import { getLpProductListCols } from '@wconcept/wconcept-common/utils/lpProductListCols';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

interface SpcPageGaLogProps {
  readonly pageTitle: string;
}

function SpcPageGaLog({ pageTitle }: SpcPageGaLogProps) {
  const [productPerView] = useState(() => getLpProductListCols());
  const searchParams = useSearchParams();
  const category = searchParams.get('category');
  const previousCategory = useRef(category);
  const isCategoryChanged = previousCategory.current !== category;
  const { isMobile } = useGlobalState();

  useEffect(() => {
    previousCategory.current = category;
  }, [category]);

  if (isCategoryChanged) return null;

  return (
    <GaLog
      pageTitle={`전문관 > ${pageTitle}`}
      params={{
        itemList: isMobile ? getSpcItemListParam(productPerView) : undefined,
      }}
    />
  );
}

export default SpcPageGaLog;
